const departmentTypes = {
  FETCH_DEPARTMENTS_START: 'FETCH_DEPARTMENTS_START',
  LOADING_DEPARTMENTS: 'LOADING_CONVERSATIONS',
  SET_DEPARTMENTS: 'SET_DEPARTMENTS',
  ADD_DEPARTMENT_START: 'ADD_DEPARTMENT_START',
  EDIT_DEPARTMENT_START: 'EDIT_DEPARTMENT_START',
  DELETE_DEPARTMENT_START: 'DELETE_DEPARTMENT_START',
  SET_LOADING_DELETE_DEPARTMENT: 'SET_LOADING_DELETE_DEPARTMENT',
  SET_LOADING_EDIT_DEPARTMENT: 'SET_LOADING_EDIT_DEPARTMENT',
  SET_LOADING_EDIT_ADD_DEPARTMENT: 'SET_LOADING_EDIT_ADD_DEPARTMENT',
  REMOVE_DEPARTMENT_FROM_LIST: 'REMOVE_DEPARTMENT_FROM_LIST',
  SET_EDITED_DEPARTMENT: 'SET_EDITED_DEPARTMENT',
};

export default departmentTypes;
